import { render, staticRenderFns } from "./addPageExpenditureInvoice.vue?vue&type=template&id=6a6c681d&scoped=true&"
import script from "./addPageExpenditureInvoice.vue?vue&type=script&lang=js&"
export * from "./addPageExpenditureInvoice.vue?vue&type=script&lang=js&"
import style0 from "./addPageExpenditureInvoice.vue?vue&type=style&index=0&id=6a6c681d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6c681d",
  null
  
)

export default component.exports